import * as React from 'react'
import type { SVGProps } from 'react'

import { PijmaComponent } from '@pijma/helper-component'
import { CommonComponentProps } from '@pijma/hero-types'

export const IconCopySmall = (
  props: SVGProps<SVGSVGElement> & CommonComponentProps,
) => (
  <PijmaComponent
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    as="svg"
    commonProps={props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9999 6H8.17065C8.58249 4.83481 9.69373 4 10.9999 4H16.9999C18.6568 4 19.9999 5.34315 19.9999 7V13C19.9999 14.3062 19.1651 15.4175 17.9999 15.8293V13V7C17.9999 6.44772 17.5522 6 16.9999 6H10.9999ZM7 8C5.34315 8 4 9.34315 4 11V17C4 18.6569 5.34315 20 7 20H13C14.6569 20 16 18.6569 16 17V11C16 9.34315 14.6569 8 13 8H7ZM6 11C6 10.4477 6.44772 10 7 10H13C13.5523 10 14 10.4477 14 11V17C14 17.5523 13.5523 18 13 18H7C6.44772 18 6 17.5523 6 17V11Z"
      fill="currentColor"
    />
  </PijmaComponent>
)
